import { useState, useEffect } from 'react';
import { Spinner } from 'components/base/Spinner';
import './TextSuggestionPanel.css';

const TextSuggestionPanel = ({ visible, onClose, onAccept, suggestions = [], suggestionsLoading = false }) => {
  const [index, setIndex] = useState(0);
  const [definitions, setDefinitions] = useState([]);

  useEffect(() => {
    setDefinitions(suggestions.length > 0 ? [...suggestions] : []);
    setIndex(0);
  }, [suggestions]);

  if (!visible) return null;

  const prev = () => setIndex(i => (i - 1 + definitions.length) % definitions.length);
  const next = () => setIndex(i => (i + 1) % definitions.length);

  const handleEdit = (e) => {
    const updated = [...definitions];
    updated[index] = e.target.value;
    setDefinitions(updated);
  };

  const handleAccept = () => {
    onAccept(definitions[index]);
    onClose();
  };

  const renderContent = () => {
    if (suggestionsLoading) {
      return <Spinner />;
    }
    if (definitions.length === 0) {
      return <p className="text-suggestion-status">No definitions found.</p>;
    }
    return (
      <>
        <span className="text-suggestion-counter">{index + 1} / {definitions.length}</span>
        <textarea
          className="text-suggestion-textarea"
          value={definitions[index]}
          onChange={handleEdit}
        />
      </>
    );
  };

  return (
    <div className="text-suggestion-panel">
      <button className="text-suggestion-close" onClick={onClose}>✕</button>
      {!suggestionsLoading && definitions.length > 0 && (
        <button className="text-suggestion-arrow" onClick={prev}>▲</button>
      )}
      <div className="text-suggestion-content">
        {renderContent()}
      </div>
      {!suggestionsLoading && definitions.length > 0 && (
        <button className="text-suggestion-arrow" onClick={next}>▼</button>
      )}
      {!suggestionsLoading && definitions.length > 0 && (
        <button className="text-suggestion-accept" onClick={handleAccept}>Accept ✓</button>
      )}
    </div>
  );
};

export { TextSuggestionPanel };
